/** Modify the year/month/date of a date object. Returns a copy. */
export const dateSetDate = (
  date: Date,
  year: number,
  monthInd: number,
  day: number
) => {
  const newDate = new Date(date);
  newDate.setFullYear(year);
  newDate.setMonth(monthInd);
  newDate.setDate(day);
  return newDate;
};

/** Modify the hour/minute/second/millisecond of a date object. Returns a copy. */
export const dateSetTime = (
  date: Date,
  hour: number,
  minute: number,
  second: number = 0,
  milli: number = 0
): Date => {
  const newDate = new Date(date);
  newDate.setHours(hour);
  newDate.setMinutes(minute);
  newDate.setSeconds(second);
  newDate.setMilliseconds(milli);
  return newDate;
};
